// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c8c83c5e","455":"c8bca80f","977":"0fc51d78"}[chunkId] + ".chunk.js";
};